import { v4 as uuid } from 'uuid';

import type { AuditLogEventCreateParams } from 'chaika-frontend-types/frontend-cms';
import { AuditLogApi } from '@api/AuditLogApi';
import { store } from '@store';
import { DateHelper } from '@utils/DateHelper';
import { Optional } from 'chaika-common-types';

interface EventData extends Omit<AuditLogEventCreateParams, 'occurredOn' | 'id' | 'userId' | 'entityId'> {
    entityId: Optional<string>;
}

class AuditLogService {
    public async logEvent(event: EventData): Promise<void> {
        AuditLogApi.addEvent(this.makeEvent(event));
    }

    public async logEvents(events: EventData[]): Promise<void> {
        const occurredOn = DateHelper.now().toISOString();
        AuditLogApi.addEvents(
            events.map(event => ({
                ...this.makeEvent(event),
                occurredOn,
            })),
        );
    }

    private makeEvent(event: EventData): AuditLogEventCreateParams {
        return {
            ...event,
            id: uuid(),
            userId: store.authUser.id,
            occurredOn: new Date().toISOString(),
        };
    }
}

export const auditLogService = new AuditLogService();
